// Emergent-managed Google OAuth launcher.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { api } from "@/lib/api";

const NEXT_KEY = "lti_post_login_next";

// Decide where a user lands after authenticating. Students with an in-progress
// asset resume straight into it (with a gentle welcome-back cue); everyone else
// follows the normal role/onboarding routing.
export async function resolveLanding(user, next) {
  if (!user) return "/login";
  if (user.role === "founder") return "/founder";
  if (!user.onboarding_complete) return "/onboarding";
  if (next) return next;
  try {
    const { data } = await api.get("/dashboard");
    const f = data.focus;
    if (f && f.status === "in_progress") return `/task/${f.slug}?resume=1`;
  } catch {
    /* ignore, fall back to dashboard */
  }
  return "/dashboard";
}

// Preserve a deep-link destination across the OAuth round trip (comes back as a URL hash).
export function startGoogleLogin(next) {
  try {
    if (next) localStorage.setItem(NEXT_KEY, next);
    else localStorage.removeItem(NEXT_KEY);
  } catch {
    /* ignore */
  }
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function consumePostLoginNext() {
  try {
    const v = localStorage.getItem(NEXT_KEY);
    localStorage.removeItem(NEXT_KEY);
    return v;
  } catch {
    return null;
  }
}
